export const countries = [
  {
    id: 4,
    flagImg: '/r/assets/images/flags/af.svg',
    countryName: 'Afghanistan',
    countryCode: '+93',
  },
  {
    id: 15,
    flagImg: '/r/assets/images/flags/ax.svg',
    countryName: 'Aland Islands',
    countryCode: '+358',
  },
  {
    id: 259,
    flagImg: '/r/assets/images/flags/al.svg',
    countryName: 'Albania',
    countryCode: '+355',
  },
  {
    id: 63,
    flagImg: '/r/assets/images/flags/dz.svg',
    countryName: 'Algeria',
    countryCode: '+213',
  },
  {
    id: 11,
    flagImg: '/r/assets/images/flags/as.svg',
    countryName: 'American Samoa',
    countryCode: '+1',
  },
  {
    id: 2,
    flagImg: '/r/assets/images/flags/ad.svg',
    countryName: 'Andorra',
    countryCode: '+376',
  },
  {
    id: 8,
    flagImg: '/r/assets/images/flags/ao.svg',
    countryName: 'Angola',
    countryCode: '+244',
  },
  {
    id: 6,
    flagImg: '/r/assets/images/flags/ai.svg',
    countryName: 'Anguilla',
    countryCode: '+1',
  },
  {
    id: 9,
    flagImg: '/r/assets/images/flags/aq.svg',
    countryName: 'Antarctica',
    countryCode: '+672',
  },
  {
    id: 5,
    flagImg: '/r/assets/images/flags/ag.svg',
    countryName: 'Antigua and Barbuda',
    countryCode: '+93',
  },
  {
    id: 10,
    flagImg: '/r/assets/images/flags/ar.svg',
    countryName: 'Argentina',
    countryCode: '+54',
  },
  {
    id: 7,
    flagImg: '/r/assets/images/flags/am.svg',
    countryName: 'Armenia',
    countryCode: '+374',
  },
  {
    id: 14,
    flagImg: '/r/assets/images/flags/aw.svg',
    countryName: 'Aruba',
    countryCode: '+297',
  },
  {
    id: 1,
    flagImg: '/r/assets/images/flags/ac.svg',
    countryName: 'Ascension Island',
    countryCode: '+247',
  },
  {
    id: 13,
    flagImg: '/r/assets/images/flags/au.svg',
    countryName: 'Australia',
    countryCode: '+61',
  },
  {
    id: 12,
    flagImg: '/r/assets/images/flags/at.svg',
    countryName: 'Austria',
    countryCode: '+43',
  },
  {
    id: 260,
    flagImg: '/r/assets/images/flags/az.svg',
    countryName: 'Azerbaijan',
    countryCode: '+994',
  },
  {
    id: 31,
    flagImg: '/r/assets/images/flags/bs.svg',
    countryName: 'Bahamas',
    countryCode: '+1',
  },
  {
    id: 22,
    flagImg: '/r/assets/images/flags/bh.svg',
    countryName: 'Bahrain',
    countryCode: '+973',
  },
  {
    id: 18,
    flagImg: '/r/assets/images/flags/bd.svg',
    countryName: 'Bangladesh',
    countryCode: '+880',
  },
  {
    id: 17,
    flagImg: '/r/assets/images/flags/bb.svg',
    countryName: 'Barbados',
    countryCode: '+1',
  },
  {
    id: 35,
    flagImg: '/r/assets/images/flags/by.svg',
    countryName: 'Belarus',
    countryCode: '+375',
  },
  {
    id: 19,
    flagImg: '/r/assets/images/flags/be.svg',
    countryName: 'Belgium',
    countryCode: '+32',
  },
  {
    id: 36,
    flagImg: '/r/assets/images/flags/bz.svg',
    countryName: 'Belize',
    countryCode: '+501',
  },
  {
    id: 24,
    flagImg: '/r/assets/images/flags/bj.svg',
    countryName: 'Benin',
    countryCode: '+229',
  },
  {
    id: 26,
    flagImg: '/r/assets/images/flags/bm.svg',
    countryName: 'Bermuda',
    countryCode: '+1',
  },
  {
    id: 32,
    flagImg: '/r/assets/images/flags/bt.svg',
    countryName: 'Bhutan',
    countryCode: '+975',
  },
  {
    id: 28,
    flagImg: '/r/assets/images/flags/bo.svg',
    countryName: 'Bolivia (Plurinational State of)',
    countryCode: '+591',
  },
  {
    id: 29,
    flagImg: '/r/assets/images/flags/bq.svg',
    countryName: 'Bonaire, Sint Eustatius and Saba',
    countryCode: '+599',
  },
  {
    id: 16,
    flagImg: '/r/assets/images/flags/ba.svg',
    countryName: 'Bosnia and Herzegovina',
    countryCode: '+387',
  },
  {
    id: 34,
    flagImg: '/r/assets/images/flags/bw.svg',
    countryName: 'Botswana',
    countryCode: '+267',
  },
  {
    id: 33,
    flagImg: '/r/assets/images/flags/bv.svg',
    countryName: 'Bouvet Island',
    countryCode: '+47',
  },
  {
    id: 30,
    flagImg: '/r/assets/images/flags/br.svg',
    countryName: 'Brazil',
    countryCode: '+55',
  },
  {
    id: 113,
    flagImg: '/r/assets/images/flags/io.svg',
    countryName: 'British Indian Ocean Territory',
    countryCode: '+246',
  },
  {
    id: 27,
    flagImg: '/r/assets/images/flags/bn.svg',
    countryName: 'Brunei Darussalam',
    countryCode: '+673',
  },
  {
    id: 21,
    flagImg: '/r/assets/images/flags/bg.svg',
    countryName: 'Bulgaria',
    countryCode: '+359',
  },
  {
    id: 20,
    flagImg: '/r/assets/images/flags/bf.svg',
    countryName: 'Burkina Faso',
    countryCode: '+226',
  },
  {
    id: 23,
    flagImg: '/r/assets/images/flags/bi.svg',
    countryName: 'Burundi',
    countryCode: '+257',
  },
  {
    id: 52,
    flagImg: '/r/assets/images/flags/cv.svg',
    countryName: 'Cabo Verde',
    countryCode: '+238',
  },
  {
    id: 124,
    flagImg: '/r/assets/images/flags/kh.svg',
    countryName: 'Cambodia',
    countryCode: '+855',
  },
  {
    id: 46,
    flagImg: '/r/assets/images/flags/cm.svg',
    countryName: 'Cameroon',
    countryCode: '+237',
  },
  {
    id: 37,
    flagImg: '/r/assets/images/flags/ca.svg',
    countryName: 'Canada',
    countryCode: '+1',
  },
  {
    id: 263,
    flagImg: '/r/assets/images/flags/ic.svg',
    countryName: 'Canary Islands',
    countryCode: '+34',
  },
  {
    id: 71,
    flagImg: '/r/assets/images/flags/es-ct.svg',
    countryName: 'Catalonia',
    countryCode: '+34',
  },
  {
    id: 131,
    flagImg: '/r/assets/images/flags/ky.svg',
    countryName: 'Cayman Islands',
    countryCode: '+1',
  },
  {
    id: 40,
    flagImg: '/r/assets/images/flags/cf.svg',
    countryName: 'Central African Republic',
    countryCode: '+236',
  },
  {
    id: 64,
    flagImg: '/r/assets/images/flags/ea.svg',
    countryName: 'Ceuta & Melilla',
    countryCode: '34',
  },
  {
    id: 224,
    flagImg: '/r/assets/images/flags/td.svg',
    countryName: 'Chad',
    countryCode: '+235',
  },
  {
    id: 45,
    flagImg: '/r/assets/images/flags/cl.svg',
    countryName: 'Chile',
    countryCode: '+56',
  },
  {
    id: 47,
    flagImg: '/r/assets/images/flags/cn.svg',
    countryName: 'China',
    countryCode: '+86',
  },
  {
    id: 54,
    flagImg: '/r/assets/images/flags/cx.svg',
    countryName: 'Christmas Island',
    countryCode: '+61',
  },
  {
    id: 49,
    flagImg: '/r/assets/images/flags/cp.svg',
    countryName: 'Clipperton Island',
    countryCode: '+55',
  },
  {
    id: 38,
    flagImg: '/r/assets/images/flags/cc.svg',
    countryName: 'Cocos (Keeling) Island',
    countryCode: '+61',
  },
  {
    id: 48,
    flagImg: '/r/assets/images/flags/co.svg',
    countryName: 'Colombia',
    countryCode: '+57',
  },
  {
    id: 126,
    flagImg: '/r/assets/images/flags/km.svg',
    countryName: 'Comoros',
    countryCode: '+269',
  },
  {
    id: 44,
    flagImg: '/r/assets/images/flags/ck.svg',
    countryName: 'Cook Islands',
    countryCode: '+682',
  },
  {
    id: 50,
    flagImg: '/r/assets/images/flags/cr.svg',
    countryName: 'Costa Rica',
    countryCode: '+506',
  },
  {
    id: 105,
    flagImg: '/r/assets/images/flags/hr.svg',
    countryName: 'Croatia',
    countryCode: '+385',
  },
  {
    id: 51,
    flagImg: '/r/assets/images/flags/cu.svg',
    countryName: 'Cuba',
    countryCode: '+53',
  },
  {
    id: 53,
    flagImg: '/r/assets/images/flags/cw.svg',
    countryName: 'Curaçao',
    countryCode: '+599',
  },
  {
    id: 55,
    flagImg: '/r/assets/images/flags/cy.svg',
    countryName: 'Cyprus',
    countryCode: '+357',
  },
  {
    id: 56,
    flagImg: '/r/assets/images/flags/cz.svg',
    countryName: 'Czech Republic',
    countryCode: '+420',
  },
  {
    id: 39,
    flagImg: '/r/assets/images/flags/cd.svg',
    countryName: 'Democratic Republic of the Congo',
    countryCode: '+243',
  },
  {
    id: 60,
    flagImg: '/r/assets/images/flags/dk.svg',
    countryName: 'Denmark',
    countryCode: '+45',
  },
  {
    id: 58,
    flagImg: '/r/assets/images/flags/dg.svg',
    countryName: 'Diego Garcia',
    countryCode: '+246',
  },
  {
    id: 59,
    flagImg: '/r/assets/images/flags/dj.svg',
    countryName: 'Djibouti',
    countryCode: '+253',
  },
  {
    id: 61,
    flagImg: '/r/assets/images/flags/dm.svg',
    countryName: 'Dominica',
    countryCode: '+1',
  },
  {
    id: 62,
    flagImg: '/r/assets/images/flags/do.svg',
    countryName: 'Dominican Republic',
    countryCode: '+1',
  },
  {
    id: 65,
    flagImg: '/r/assets/images/flags/ec.svg',
    countryName: 'Ecuador',
    countryCode: '+593',
  },
  {
    id: 67,
    flagImg: '/r/assets/images/flags/eg.svg',
    countryName: 'Egypt',
    countryCode: '+20',
  },
  {
    id: 218,
    flagImg: '/r/assets/images/flags/sv.svg',
    countryName: 'El Salvador',
    countryCode: '+503',
  },
  {
    id: 82,
    flagImg: '/r/assets/images/flags/gb-eng.svg',
    countryName: 'England',
    countryCode: '+44',
  },
  {
    id: 96,
    flagImg: '/r/assets/images/flags/gq.svg',
    countryName: 'Equatorial Guinea',
    countryCode: '+240',
  },
  {
    id: 69,
    flagImg: '/r/assets/images/flags/er.svg',
    countryName: 'Eritrea',
    countryCode: '+291',
  },
  {
    id: 66,
    flagImg: '/r/assets/images/flags/ee.svg',
    countryName: 'Estonia',
    countryCode: '+372',
  },
  {
    id: 221,
    flagImg: '/r/assets/images/flags/sz.svg',
    countryName: 'Eswatini',
    countryCode: '+268',
  },
  {
    id: 73,
    flagImg: '/r/assets/images/flags/et.svg',
    countryName: 'Ethiopia',
    countryCode: '+251',
  },
  {
    id: 74,
    flagImg: '/r/assets/images/flags/eu.svg',
    countryName: 'Europe',
    countryCode: '+3',
  },
  {
    id: 77,
    flagImg: '/r/assets/images/flags/fk.svg',
    countryName: 'Falkland Islands',
    countryCode: '+500',
  },
  {
    id: 79,
    flagImg: '/r/assets/images/flags/fo.svg',
    countryName: 'Faroe Islands',
    countryCode: '+298',
  },
  {
    id: 78,
    flagImg: '/r/assets/images/flags/fm.svg',
    countryName: 'Federated States of Micronesia',
    countryCode: '+691',
  },
  {
    id: 76,
    flagImg: '/r/assets/images/flags/fj.svg',
    countryName: 'Fiji',
    countryCode: '+679',
  },
  {
    id: 75,
    flagImg: '/r/assets/images/flags/fi.svg',
    countryName: 'Finland',
    countryCode: '+358',
  },
  {
    id: 80,
    flagImg: '/r/assets/images/flags/fr.svg',
    countryName: 'France',
    countryCode: '+33',
  },
  {
    id: 88,
    flagImg: '/r/assets/images/flags/gf.svg',
    countryName: 'French Guiana',
    countryCode: '+594',
  },
  {
    id: 182,
    flagImg: '/r/assets/images/flags/pf.svg',
    countryName: 'French Polynesia',
    countryCode: '+689',
  },
  {
    id: 265,
    flagImg: '/r/assets/images/flags/tf.svg',
    countryName: 'French Southern Territories',
    countryCode: '+262',
  },
  {
    id: 81,
    flagImg: '/r/assets/images/flags/ga.svg',
    countryName: 'Gabon',
    countryCode: '+241',
  },
  {
    id: 72,
    flagImg: '/r/assets/images/flags/es-ga.svg',
    countryName: 'Galicia',
    countryCode: '+34',
  },
  {
    id: 93,
    flagImg: '/r/assets/images/flags/gm.svg',
    countryName: 'Gambia',
    countryCode: '+220',
  },
  {
    id: 87,
    flagImg: '/r/assets/images/flags/ge.svg',
    countryName: 'Georgia',
    countryCode: '+995',
  },
  {
    id: 57,
    flagImg: '/r/assets/images/flags/de.svg',
    countryName: 'Germany',
    countryCode: '+49',
  },
  {
    id: 90,
    flagImg: '/r/assets/images/flags/gh.svg',
    countryName: 'Ghana',
    countryCode: '+233',
  },
  {
    id: 91,
    flagImg: '/r/assets/images/flags/gi.svg',
    countryName: 'Gibraltar',
    countryCode: '+350',
  },
  {
    id: 97,
    flagImg: '/r/assets/images/flags/gr.svg',
    countryName: 'Greece',
    countryCode: '+30',
  },
  {
    id: 92,
    flagImg: '/r/assets/images/flags/gl.svg',
    countryName: 'Greenland',
    countryCode: '+299',
  },
  {
    id: 86,
    flagImg: '/r/assets/images/flags/gd.svg',
    countryName: 'Grenada',
    countryCode: '+1',
  },
  {
    id: 95,
    flagImg: '/r/assets/images/flags/gp.svg',
    countryName: 'Guadeloupe',
    countryCode: '+590',
  },
  {
    id: 100,
    flagImg: '/r/assets/images/flags/gu.svg',
    countryName: 'Guam',
    countryCode: '+1',
  },
  {
    id: 99,
    flagImg: '/r/assets/images/flags/gt.svg',
    countryName: 'Guatemala',
    countryCode: '+502',
  },
  {
    id: 89,
    flagImg: '/r/assets/images/flags/gg.svg',
    countryName: 'Guernsey',
    countryCode: '+44',
  },
  {
    id: 94,
    flagImg: '/r/assets/images/flags/gn.svg',
    countryName: 'Guinea',
    countryCode: '+224',
  },
  {
    id: 101,
    flagImg: '/r/assets/images/flags/gw.svg',
    countryName: 'Guinea-Bissau',
    countryCode: '+245',
  },
  {
    id: 102,
    flagImg: '/r/assets/images/flags/gy.svg',
    countryName: 'Guyana',
    countryCode: '+592',
  },
  {
    id: 106,
    flagImg: '/r/assets/images/flags/ht.svg',
    countryName: 'Haiti',
    countryCode: '+509',
  },
  {
    id: 262,
    flagImg: '/r/assets/images/flags/hm.svg',
    countryName: 'Heard Island and McDonald Islands',
    countryCode: '',
  },
  {
    id: 244,
    flagImg: '/r/assets/images/flags/va.svg',
    countryName: 'Holy See',
    countryCode: '+379',
  },
  {
    id: 104,
    flagImg: '/r/assets/images/flags/hn.svg',
    countryName: 'Honduras',
    countryCode: '+504',
  },
  {
    id: 103,
    flagImg: '/r/assets/images/flags/hk.svg',
    countryName: 'Hong Kong',
    countryCode: '+852',
  },
  {
    id: 107,
    flagImg: '/r/assets/images/flags/hu.svg',
    countryName: 'Hungary',
    countryCode: '+36',
  },
  {
    id: 116,
    flagImg: '/r/assets/images/flags/is.svg',
    countryName: 'Iceland',
    countryCode: '+354',
  },
  {
    id: 112,
    flagImg: '/r/assets/images/flags/in.svg',
    countryName: 'India',
    countryCode: '+91',
  },
  {
    id: 108,
    flagImg: '/r/assets/images/flags/id.svg',
    countryName: 'Indonesia',
    countryCode: '+62',
  },
  {
    id: 115,
    flagImg: '/r/assets/images/flags/ir.svg',
    countryName: 'Iran (Islamic Republic of)',
    countryCode: '+98',
  },
  {
    id: 114,
    flagImg: '/r/assets/images/flags/iq.svg',
    countryName: 'Iraq',
    countryCode: '+964',
  },
  {
    id: 109,
    flagImg: '/r/assets/images/flags/ie.svg',
    countryName: 'Ireland',
    countryCode: '+353',
  },
  {
    id: 111,
    flagImg: '/r/assets/images/flags/im.svg',
    countryName: 'Isle of Man',
    countryCode: '+44',
  },
  {
    id: 110,
    flagImg: '/r/assets/images/flags/il.svg',
    countryName: 'Israel',
    countryCode: '+972',
  },
  {
    id: 117,
    flagImg: '/r/assets/images/flags/it.svg',
    countryName: 'Italy',
    countryCode: '+39',
  },
  {
    id: 43,
    flagImg: '/r/assets/images/flags/ci.svg',
    countryName: 'Ivory Coast',
    countryCode: '+225',
  },
  {
    id: 119,
    flagImg: '/r/assets/images/flags/jm.svg',
    countryName: 'Jamaica',
    countryCode: '+1',
  },
  {
    id: 121,
    flagImg: '/r/assets/images/flags/jp.svg',
    countryName: 'Japan',
    countryCode: '+81',
  },
  {
    id: 118,
    flagImg: '/r/assets/images/flags/je.svg',
    countryName: 'Jersey',
    countryCode: '+44',
  },
  {
    id: 120,
    flagImg: '/r/assets/images/flags/jo.svg',
    countryName: 'Jordan',
    countryCode: '+962',
  },
  {
    id: 132,
    flagImg: '/r/assets/images/flags/kz.svg',
    countryName: 'Kazakhstan',
    countryCode: '+7',
  },
  {
    id: 122,
    flagImg: '/r/assets/images/flags/ke.svg',
    countryName: 'Kenya',
    countryCode: '+254',
  },
  {
    id: 125,
    flagImg: '/r/assets/images/flags/ki.svg',
    countryName: 'Kiribati',
    countryCode: '+686',
  },
  {
    id: 253,
    flagImg: '/r/assets/images/flags/xk.svg',
    countryName: 'Kosovo',
    countryCode: '+383',
  },
  {
    id: 130,
    flagImg: '/r/assets/images/flags/kw.svg',
    countryName: 'Kuwait',
    countryCode: '+965',
  },
  {
    id: 123,
    flagImg: '/r/assets/images/flags/kg.svg',
    countryName: 'Kyrgyzstan',
    countryCode: '+996',
  },
  {
    id: 133,
    flagImg: '/r/assets/images/flags/la.svg',
    countryName: 'Laos',
    countryCode: '+856',
  },
  {
    id: 142,
    flagImg: '/r/assets/images/flags/lv.svg',
    countryName: 'Latvia',
    countryCode: '+371',
  },
  {
    id: 134,
    flagImg: '/r/assets/images/flags/lb.svg',
    countryName: 'Lebanon',
    countryCode: '+961',
  },
  {
    id: 139,
    flagImg: '/r/assets/images/flags/ls.svg',
    countryName: 'Lesotho',
    countryCode: '+266',
  },
  {
    id: 138,
    flagImg: '/r/assets/images/flags/lr.svg',
    countryName: 'Liberia',
    countryCode: '+231',
  },
  {
    id: 143,
    flagImg: '/r/assets/images/flags/ly.svg',
    countryName: 'Libya',
    countryCode: '+218',
  },
  {
    id: 136,
    flagImg: '/r/assets/images/flags/li.svg',
    countryName: 'Liechtenstein',
    countryCode: '+423',
  },
  {
    id: 140,
    flagImg: '/r/assets/images/flags/lt.svg',
    countryName: 'Lithuania',
    countryCode: '+370',
  },
  {
    id: 141,
    flagImg: '/r/assets/images/flags/lu.svg',
    countryName: 'Luxembourg',
    countryCode: '+352',
  },
  {
    id: 155,
    flagImg: '/r/assets/images/flags/mo.svg',
    countryName: 'Macau',
    countryCode: '+853',
  },
  {
    id: 149,
    flagImg: '/r/assets/images/flags/mg.svg',
    countryName: 'Madagascar',
    countryCode: '+261',
  },
  {
    id: 163,
    flagImg: '/r/assets/images/flags/mw.svg',
    countryName: 'Malawi',
    countryCode: '+265',
  },
  {
    id: 165,
    flagImg: '/r/assets/images/flags/my.svg',
    countryName: 'Malaysia',
    countryCode: '+60',
  },
  {
    id: 162,
    flagImg: '/r/assets/images/flags/mv.svg',
    countryName: 'Maldives',
    countryCode: '+960',
  },
  {
    id: 152,
    flagImg: '/r/assets/images/flags/ml.svg',
    countryName: 'Mali',
    countryCode: '+223',
  },
  {
    id: 160,
    flagImg: '/r/assets/images/flags/mt.svg',
    countryName: 'Malta',
    countryCode: '+356',
  },
  {
    id: 150,
    flagImg: '/r/assets/images/flags/mh.svg',
    countryName: 'Marshall Islands',
    countryCode: '+692',
  },
  {
    id: 157,
    flagImg: '/r/assets/images/flags/mq.svg',
    countryName: 'Martinique',
    countryCode: '+596',
  },
  {
    id: 158,
    flagImg: '/r/assets/images/flags/mr.svg',
    countryName: 'Mauritania',
    countryCode: '+222',
  },
  {
    id: 161,
    flagImg: '/r/assets/images/flags/mu.svg',
    countryName: 'Mauritius',
    countryCode: '+230',
  },
  {
    id: 255,
    flagImg: '/r/assets/images/flags/yt.svg',
    countryName: 'Mayotte',
    countryCode: '+262',
  },
  {
    id: 164,
    flagImg: '/r/assets/images/flags/mx.svg',
    countryName: 'Mexico',
    countryCode: '+52',
  },
  {
    id: 146,
    flagImg: '/r/assets/images/flags/md.svg',
    countryName: 'Moldova',
    countryCode: '+373',
  },
  {
    id: 145,
    flagImg: '/r/assets/images/flags/mc.svg',
    countryName: 'Monaco',
    countryCode: '+377',
  },
  {
    id: 154,
    flagImg: '/r/assets/images/flags/mn.svg',
    countryName: 'Mongolia',
    countryCode: '+976',
  },
  {
    id: 147,
    flagImg: '/r/assets/images/flags/me.svg',
    countryName: 'Montenegro',
    countryCode: '+382',
  },
  {
    id: 159,
    flagImg: '/r/assets/images/flags/ms.svg',
    countryName: 'Montserrat',
    countryCode: '+1',
  },
  {
    id: 144,
    flagImg: '/r/assets/images/flags/ma.svg',
    countryName: 'Morocco',
    countryCode: '+212',
  },
  {
    id: 166,
    flagImg: '/r/assets/images/flags/mz.svg',
    countryName: 'Mozambique',
    countryCode: '+258',
  },
  {
    id: 153,
    flagImg: '/r/assets/images/flags/mm.svg',
    countryName: 'Myanmar',
    countryCode: '+95',
  },
  {
    id: 167,
    flagImg: '/r/assets/images/flags/na.svg',
    countryName: 'Namibia',
    countryCode: '+264',
  },
  {
    id: 176,
    flagImg: '/r/assets/images/flags/nr.svg',
    countryName: 'Nauru',
    countryCode: '+674',
  },
  {
    id: 175,
    flagImg: '/r/assets/images/flags/np.svg',
    countryName: 'Nepal',
    countryCode: '+977',
  },
  {
    id: 173,
    flagImg: '/r/assets/images/flags/nl.svg',
    countryName: 'Netherlands',
    countryCode: '+31',
  },
  {
    id: 168,
    flagImg: '/r/assets/images/flags/nc.svg',
    countryName: 'New Caledonia',
    countryCode: '+687',
  },
  {
    id: 178,
    flagImg: '/r/assets/images/flags/nz.svg',
    countryName: 'New Zealand',
    countryCode: '+64',
  },
  {
    id: 172,
    flagImg: '/r/assets/images/flags/ni.svg',
    countryName: 'Nicaragua',
    countryCode: '+505',
  },
  {
    id: 169,
    flagImg: '/r/assets/images/flags/ne.svg',
    countryName: 'Niger',
    countryCode: '+227',
  },
  {
    id: 171,
    flagImg: '/r/assets/images/flags/ng.svg',
    countryName: 'Nigeria',
    countryCode: '+234',
  },
  {
    id: 177,
    flagImg: '/r/assets/images/flags/nu.svg',
    countryName: 'Niue',
    countryCode: '+683',
  },
  {
    id: 170,
    flagImg: '/r/assets/images/flags/nf.svg',
    countryName: 'Norfolk Island',
    countryCode: '+672',
  },
  {
    id: 128,
    flagImg: '/r/assets/images/flags/kp.svg',
    countryName: 'North Korea',
    countryCode: '+850',
  },
  {
    id: 151,
    flagImg: '/r/assets/images/flags/mk.svg',
    countryName: 'North Macedonia',
    countryCode: '+389',
  },
  {
    id: 83,
    flagImg: '/r/assets/images/flags/gb-nir.svg',
    countryName: 'Northern Ireland',
    countryCode: '+44',
  },
  {
    id: 156,
    flagImg: '/r/assets/images/flags/mp.svg',
    countryName: 'Northern Mariana Islands',
    countryCode: '+1',
  },
  {
    id: 174,
    flagImg: '/r/assets/images/flags/no.svg',
    countryName: 'Norway',
    countryCode: '+47',
  },
  {
    id: 179,
    flagImg: '/r/assets/images/flags/om.svg',
    countryName: 'Oman',
    countryCode: '+968',
  },
  {
    id: 185,
    flagImg: '/r/assets/images/flags/pk.svg',
    countryName: 'Pakistan',
    countryCode: '+92',
  },
  {
    id: 192,
    flagImg: '/r/assets/images/flags/pw.svg',
    countryName: 'Palau',
    countryCode: '+680',
  },
  {
    id: 180,
    flagImg: '/r/assets/images/flags/pa.svg',
    countryName: 'Panama',
    countryCode: '+507',
  },
  {
    id: 183,
    flagImg: '/r/assets/images/flags/pg.svg',
    countryName: 'Papua New Guinea',
    countryCode: '+675',
  },
  {
    id: 193,
    flagImg: '/r/assets/images/flags/py.svg',
    countryName: 'Paraguay',
    countryCode: '+595',
  },
  {
    id: 181,
    flagImg: '/r/assets/images/flags/pe.svg',
    countryName: 'Peru',
    countryCode: '+51',
  },
  {
    id: 184,
    flagImg: '/r/assets/images/flags/ph.svg',
    countryName: 'Philippines',
    countryCode: '+63',
  },
  {
    id: 188,
    flagImg: '/r/assets/images/flags/pn.svg',
    countryName: 'Pitcairn',
    countryCode: '+64',
  },
  {
    id: 186,
    flagImg: '/r/assets/images/flags/pl.svg',
    countryName: 'Poland',
    countryCode: '+48',
  },
  {
    id: 191,
    flagImg: '/r/assets/images/flags/pt.svg',
    countryName: 'Portugal',
    countryCode: '+351',
  },
  {
    id: 189,
    flagImg: '/r/assets/images/flags/pr.svg',
    countryName: 'Puerto Rico',
    countryCode: '+1',
  },
  {
    id: 194,
    flagImg: '/r/assets/images/flags/qa.svg',
    countryName: 'Qatar',
    countryCode: '+974',
  },
  {
    id: 41,
    flagImg: '/r/assets/images/flags/cg.svg',
    countryName: 'Republic of the Congo',
    countryCode: '+243',
  },
  {
    id: 195,
    flagImg: '/r/assets/images/flags/re.svg',
    countryName: 'Réunion',
    countryCode: '+262',
  },
  {
    id: 196,
    flagImg: '/r/assets/images/flags/ro.svg',
    countryName: 'Romania',
    countryCode: '+40',
  },
  {
    id: 198,
    flagImg: '/r/assets/images/flags/ru.svg',
    countryName: 'Russia',
    countryCode: '+7',
  },
  {
    id: 199,
    flagImg: '/r/assets/images/flags/rw.svg',
    countryName: 'Rwanda',
    countryCode: '+250',
  },
  {
    id: 25,
    flagImg: '/r/assets/images/flags/bl.svg',
    countryName: 'Saint Barthélemy',
    countryCode: '+590',
  },
  {
    id: 264,
    flagImg: '/r/assets/images/flags/sh.svg',
    countryName: 'Saint Helena',
    countryCode: '+290',
  },
  {
    id: 127,
    flagImg: '/r/assets/images/flags/kn.svg',
    countryName: 'Saint Kitts and Nevis',
    countryCode: '+1',
  },
  {
    id: 135,
    flagImg: '/r/assets/images/flags/lc.svg',
    countryName: 'Saint Lucia',
    countryCode: '+1',
  },
  {
    id: 148,
    flagImg: '/r/assets/images/flags/mf.svg',
    countryName: 'Saint Martin',
    countryCode: '+721',
  },
  {
    id: 187,
    flagImg: '/r/assets/images/flags/pm.svg',
    countryName: 'Saint Pierre and Miquelon',
    countryCode: '+508',
  },
  {
    id: 245,
    flagImg: '/r/assets/images/flags/vc.svg',
    countryName: 'Saint Vincent and the Grenadines',
    countryCode: '+1',
  },
  {
    id: 252,
    flagImg: '/r/assets/images/flags/ws.svg',
    countryName: 'Samoa',
    countryCode: '+685',
  },
  {
    id: 212,
    flagImg: '/r/assets/images/flags/sm.svg',
    countryName: 'San Marino',
    countryCode: '+378',
  },
  {
    id: 217,
    flagImg: '/r/assets/images/flags/st.svg',
    countryName: 'Sao Tome and Principe',
    countryCode: '+239',
  },
  {
    id: 200,
    flagImg: '/r/assets/images/flags/sa.svg',
    countryName: 'Saudi Arabia',
    countryCode: '+966',
  },
  {
    id: 84,
    flagImg: '/r/assets/images/flags/gb-sct.svg',
    countryName: 'Scotland',
    countryCode: '+44',
  },
  {
    id: 213,
    flagImg: '/r/assets/images/flags/sn.svg',
    countryName: 'Senegal',
    countryCode: '+221',
  },
  {
    id: 197,
    flagImg: '/r/assets/images/flags/rs.svg',
    countryName: 'Serbia',
    countryCode: '+381',
  },
  {
    id: 202,
    flagImg: '/r/assets/images/flags/sc.svg',
    countryName: 'Seychelles',
    countryCode: '+248',
  },
  {
    id: 210,
    flagImg: '/r/assets/images/flags/sl.svg',
    countryName: 'Sierra Leone',
    countryCode: '+232',
  },
  {
    id: 205,
    flagImg: '/r/assets/images/flags/sg.svg',
    countryName: 'Singapore',
    countryCode: '+65',
  },
  {
    id: 219,
    flagImg: '/r/assets/images/flags/sx.svg',
    countryName: 'Sint Maarten',
    countryCode: '+721',
  },
  {
    id: 209,
    flagImg: '/r/assets/images/flags/sk.svg',
    countryName: 'Slovakia',
    countryCode: '+421',
  },
  {
    id: 207,
    flagImg: '/r/assets/images/flags/si.svg',
    countryName: 'Slovenia',
    countryCode: '+386',
  },
  {
    id: 201,
    flagImg: '/r/assets/images/flags/sb.svg',
    countryName: 'Solomon Islands',
    countryCode: '+677',
  },
  {
    id: 214,
    flagImg: '/r/assets/images/flags/so.svg',
    countryName: 'Somalia',
    countryCode: '+252',
  },
  {
    id: 256,
    flagImg: '/r/assets/images/flags/za.svg',
    countryName: 'South Africa',
    countryCode: '+27',
  },
  {
    id: 98,
    flagImg: '/r/assets/images/flags/gs.svg',
    countryName: 'South Georgia and the South Sandwich Islands',
    countryCode: '+500',
  },
  {
    id: 129,
    flagImg: '/r/assets/images/flags/kr.svg',
    countryName: 'South Korea',
    countryCode: '+82',
  },
  {
    id: 216,
    flagImg: '/r/assets/images/flags/ss.svg',
    countryName: 'South Sudan',
    countryCode: '+211',
  },
  {
    id: 70,
    flagImg: '/r/assets/images/flags/es.svg',
    countryName: 'Spain',
    countryCode: '+34',
  },
  {
    id: 137,
    flagImg: '/r/assets/images/flags/lk.svg',
    countryName: 'Sri Lanka',
    countryCode: '+94',
  },
  {
    id: 190,
    flagImg: '/r/assets/images/flags/ps.svg',
    countryName: 'State of Palestine',
    countryCode: '+970',
  },
  {
    id: 203,
    flagImg: '/r/assets/images/flags/sd.svg',
    countryName: 'Sudan',
    countryCode: '+249',
  },
  {
    id: 215,
    flagImg: '/r/assets/images/flags/sr.svg',
    countryName: 'Suriname',
    countryCode: '+597',
  },
  {
    id: 208,
    flagImg: '/r/assets/images/flags/sj.svg',
    countryName: 'Svalbard and Jan Mayen',
    countryCode: '47',
  },
  {
    id: 204,
    flagImg: '/r/assets/images/flags/se.svg',
    countryName: 'Sweden',
    countryCode: '+46',
  },
  {
    id: 42,
    flagImg: '/r/assets/images/flags/ch.svg',
    countryName: 'Switzerland',
    countryCode: '+41',
  },
  {
    id: 220,
    flagImg: '/r/assets/images/flags/sy.svg',
    countryName: 'Syria',
    countryCode: '+963',
  },
  {
    id: 236,
    flagImg: '/r/assets/images/flags/tw.svg',
    countryName: 'Taiwan',
    countryCode: '+886',
  },
  {
    id: 227,
    flagImg: '/r/assets/images/flags/tj.svg',
    countryName: 'Tajikistan',
    countryCode: '+992',
  },
  {
    id: 237,
    flagImg: '/r/assets/images/flags/tz.svg',
    countryName: 'Tanzania',
    countryCode: '+255',
  },
  {
    id: 226,
    flagImg: '/r/assets/images/flags/th.svg',
    countryName: 'Thailand',
    countryCode: '+66',
  },
  {
    id: 229,
    flagImg: '/r/assets/images/flags/tl.svg',
    countryName: 'Timor-Leste',
    countryCode: '+670',
  },
  {
    id: 225,
    flagImg: '/r/assets/images/flags/tg.svg',
    countryName: 'Togo',
    countryCode: '+228',
  },
  {
    id: 228,
    flagImg: '/r/assets/images/flags/tk.svg',
    countryName: 'Tokelau',
    countryCode: '+690',
  },
  {
    id: 232,
    flagImg: '/r/assets/images/flags/to.svg',
    countryName: 'Tonga',
    countryCode: '+676',
  },
  {
    id: 234,
    flagImg: '/r/assets/images/flags/tt.svg',
    countryName: 'Trinidad and Tobago',
    countryCode: '+1',
  },
  {
    id: 222,
    flagImg: '/r/assets/images/flags/ta.svg',
    countryName: 'Tristan da Cunha',
    countryCode: '+290',
  },
  {
    id: 231,
    flagImg: '/r/assets/images/flags/tn.svg',
    countryName: 'Tunisia',
    countryCode: '+216',
  },
  {
    id: 233,
    flagImg: '/r/assets/images/flags/tr.svg',
    countryName: 'Turkey',
    countryCode: '+90',
  },
  {
    id: 230,
    flagImg: '/r/assets/images/flags/tm.svg',
    countryName: 'Turkmenistan',
    countryCode: '+993',
  },
  {
    id: 223,
    flagImg: '/r/assets/images/flags/tc.svg',
    countryName: 'Turks and Caicos Islands',
    countryCode: '+1',
  },
  {
    id: 235,
    flagImg: '/r/assets/images/flags/tv.svg',
    countryName: 'Tuvalu',
    countryCode: '+688',
  },
  {
    id: 239,
    flagImg: '/r/assets/images/flags/ug.svg',
    countryName: 'Uganda',
    countryCode: '+256',
  },
  {
    id: 238,
    flagImg: '/r/assets/images/flags/ua.svg',
    countryName: 'Ukraine',
    countryCode: '+380',
  },
  {
    id: 3,
    flagImg: '/r/assets/images/flags/ae.svg',
    countryName: 'United Arab Emirates',
    countryCode: '+971',
  },
  {
    id: 261,
    flagImg: '/r/assets/images/flags/gb.svg',
    countryName: 'United Kingdom',
    countryCode: '+44',
  },
  {
    id: 266,
    flagImg: '/r/assets/images/flags/um.svg',
    countryName: 'United States Minor Outlying Islands',
    countryCode: '+1',
  },
  {
    id: 240,
    flagImg: '/r/assets/images/flags/us.svg',
    countryName: 'United States of America',
    countryCode: '+1',
  },
  {
    id: 242,
    flagImg: '/r/assets/images/flags/uy.svg',
    countryName: 'Uruguay',
    countryCode: '+598',
  },
  {
    id: 243,
    flagImg: '/r/assets/images/flags/uz.svg',
    countryName: 'Uzbekistan',
    countryCode: '+998',
  },
  {
    id: 250,
    flagImg: '/r/assets/images/flags/vu.svg',
    countryName: 'Vanuatu',
    countryCode: '+678',
  },
  {
    id: 246,
    flagImg: '/r/assets/images/flags/ve.svg',
    countryName: 'Venezuela (Bolivarian Republic of)',
    countryCode: '+58',
  },
  {
    id: 249,
    flagImg: '/r/assets/images/flags/vn.svg',
    countryName: 'Vietnam',
    countryCode: '+84',
  },
  {
    id: 247,
    flagImg: '/r/assets/images/flags/vg.svg',
    countryName: 'Virgin Islands (British)',
    countryCode: '+1',
  },
  {
    id: 248,
    flagImg: '/r/assets/images/flags/vi.svg',
    countryName: 'Virgin Islands (U.S.)',
    countryCode: '+1',
  },
  {
    id: 85,
    flagImg: '/r/assets/images/flags/gb-wls.svg',
    countryName: 'Wales',
    countryCode: '+44',
  },
  {
    id: 251,
    flagImg: '/r/assets/images/flags/wf.svg',
    countryName: 'Wallis and Futuna',
    countryCode: '+681',
  },
  {
    id: 68,
    flagImg: '/r/assets/images/flags/eh.svg',
    countryName: 'Western Sahara',
    countryCode: '+212',
  },
  {
    id: 254,
    flagImg: '/r/assets/images/flags/ye.svg',
    countryName: 'Yemen',
    countryCode: '+967',
  },
  {
    id: 257,
    flagImg: '/r/assets/images/flags/zm.svg',
    countryName: 'Zambia',
    countryCode: '+260',
  },
  {
    id: 258,
    flagImg: '/r/assets/images/flags/zw.svg',
    countryName: 'Zimbabwe',
    countryCode: '+263',
  },
];
